<template>
    <div class="row">
        <div class="col-12 col-md-6 col-lg-12 mb-4">
            <ul class="list-group mb-0 visit-list">
                <li class="list-group-item rounded-0">
                    <a href="/online-giving" class="d-flex align-items-center">
                        <div class="visit-icon mr-3">
                            <img src="../assets/images/donation.png" alt="" class="img-fluid" />
                        </div>
                        <div class="visit-title">
                            <router-link to="/online-giving">Online Giving</router-link>
                        </div>
                    </a>
                </li>
                <li class="list-group-item rounded-0">
                    <a href="http://www.fifmi.org" target="_blank" class="d-flex align-items-center">
                        <div class="visit-icon mr-3">
                            <img src="../assets/images/world.png" alt="" class="img-fluid" />
                        </div>
                        <div class="visit-title">Global Website</div>
                    </a>
                </li>
                <li class="list-group-item rounded-0">
                    <a href="https://ezekieltvchannel.com" target="_blank" class="d-flex align-items-center">
                        <div class="visit-icon mr-3">
                            <img src="../assets/images/tv.png" alt="" class="img-fluid" />
                        </div>
                        <div class="visit-title">Ezekiel Tv</div>
                    </a>
                </li>
                <li class="list-group-item rounded-0">
                    <a href="/bible-school" class="d-flex align-items-center">
                        <div class="visit-icon mr-3">
                            <img src="../assets/images/user.png" alt="" class="img-fluid" />
                        </div>
                        <div class="visit-title">Amfcc</div>
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-12 col-md-6 col-lg-12 mb-4">
            <div class="right-title">
                <h5>Watch Ezekiel Tv</h5>
                <a href="https://ezekieltvchannel.com" target="_blank" class="right-newsimg"><img src="../assets/images/news.jpg" alt="" class="img-fluid" /></a>
            </div>
        </div>
        <hr>
        <div class="col-12 col-md-6 col-lg-12 mb-4">
            <EventsTeaser />
        </div>
    </div>
</template>


<script>
    import axios from 'axios';
    // @ is an alias to /src
    import EventsTeaser from "./Events/EventsTeaser";
    export default {
        name: 'SideBarExtras',
        data(){
            return {
                events: []
            }
        },
        components:{
            EventsTeaser
        },
        mounted() {
            axios
                .get('https://api.fifmi.org.au/api/articles')
                .then(result => {
                    for (var i = 0; i < result.data.length; i++) {
                        if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].type == "events" && result.data[i].type == "articles"){
                            this.events.push(result.data[i])
                        }
                    }
                });
        }
    }
</script>
